export default {
    expoId: "",
    setExpoId(Id) {
        this.expoId = Id;
    }
}